// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__JVnRO","validationTips":"StatementDescriptor_validationTips__2CQIe"};